module.exports = __webpack_public_path__ + "img/agency2.7bdc65d1.png";